import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTitle } from '../../HOC';
import SFItem from './SFItem';
import { SOCIAL_NETWORKS } from './sf.config';

const SocialFollowRender = ({ isPortrait, socialNetKeys, socialNetworks }) => {
  const ulClassName = classnames({
    'social__list social__list--follow': !isPortrait,
    'social__list social__list--follow social__list--vertical': isPortrait
  });
  return (
    <ul className={ulClassName}>
      {socialNetKeys.map(socialNetKey => {
        const supportedNetwork = SOCIAL_NETWORKS[socialNetKey];
        return (
          supportedNetwork &&
          socialNetworks[socialNetKey] && (
            <SFItem key={socialNetKey} id={socialNetKey} url={socialNetworks[socialNetKey]} />
          )
        );
      })}
    </ul>
  );
};

SocialFollowRender.propTypes = {
  isPortrait: PropTypes.bool.isRequired,
  socialNetKeys: PropTypes.array.isRequired,
  socialNetworks: PropTypes.object.isRequired
};

export default withTitle(SocialFollowRender);
